export default "__VITE_PUBLIC_ASSET__8a5e68aa__"